import React, { useCallback, useState, createContext, useContext } from 'react';
import { Language, translations } from './translations';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('en');
  const t = useCallback((key: string): string => {
    return translations[language][key] || key;
  }, [language]);
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t
  }} data-id="element-759">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}